import $ from 'jquery'

$(document).on('change', '.custom-color', function () {
  const $this = $(this)
  const $input = $this.find('input')
  const $preview = $this.find('.custom-color-preview')
  if ($input.is(':valid')) {
    $this.removeClass('was-validated')
    $preview.css('background', $input.val())
  } else {
    $this.addClass('was-validated')
  }
})
